<template>
    <button @click.prevent="deleteFile" class="btn btn-danger">
        <i class="fa fa-lg fa-trash"></i>
    </button>
</template>

<script>
    import { DestroyAlert } from '~/Swals'

    export default {
        name: "fileDelete",

        data() {
            return {
            }
        },

        props: {
            documentId: {
                type: Number,
                required: true,
            }
        },

        methods: {
            async deleteFile() {
                new DestroyAlert({ entity: this.lang('app.file') }).show().then(async () => {
                    const response = await window.axios.delete(route('resource.files.destroy', { file: this.documentId }))

                    this.$emit('deleteSuccess', this.documentId)
                });
            },
        },
    }
</script>

<style scoped></style>
